import { ESection as EDeleteSection } from '../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsDeleteAllFromSectionDesktopRequestSchema';
import { ESection as EArchiveSection } from '../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequestSchema';
import { ESection as EReadSection } from '../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsReadAllFromSectionDesktopRequestSchema';

export enum ERoute {
  Messages = 'messages',
  Spam = 'spam',
  Archive = 'archive',
  Unread = 'unread',
}

export type TRoute = `${ERoute}`;

export { EArchiveSection, EReadSection, EDeleteSection };
